var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.372 12.7091H25.7007C20.4592 12.7091 17.8384 12.7091 16.2101 14.3555C14.5818 16.0019 14.5818 18.6518 14.5818 23.9515V32.9454H43.4909V23.9515C43.4909 18.6518 43.4909 16.0019 41.8626 14.3555C40.2342 12.7091 37.6135 12.7091 32.372 12.7091Z",
    fill: "#03E8AF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79993 58V27.3455C8.79993 24.584 11.0385 22.3455 13.7999 22.3455H14.5817",
    stroke: "#87FF0B",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 58V18C51.2 10.8203 45.3797 5 38.2 5H9.76367",
    stroke: "#1EF5DF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5818 32.9454V58H43.4909V32.9454H14.5818Z",
    fill: "#03A3E8",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2545 46.8744L30.2753 37.7636V44.0711H34.8182L27.7974 53.1818V46.8744H23.2545Z",
    fill: "#87FF0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5818 58V24.0318C14.5818 18.6942 14.5818 16.0254 16.2101 14.3673C17.8384 12.7091 20.4592 12.7091 25.7007 12.7091H32.372C37.6135 12.7091 40.2342 12.7091 41.8626 14.3673C43.4909 16.0254 43.4909 18.6942 43.4909 24.0318V58",
    stroke: "#1EF5DF",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94543 58L55.0545 58",
    stroke: "#87FF0B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5818 32.9454H43.4909",
    stroke: "#1EF5DF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 20,
    height: 3,
    fill: "#0D4C46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 10,
    height: 3,
    fill: "#1EF5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocStation);
export default __webpack_public_path__ + "static/media/ic_soc_station.da6406fe78fb24d34d84dc580bb1c448.svg";
export { ForwardRef as ReactComponent };